import AccountContext from 'context/AccountContext';
import useUpdateCustomerMutation from 'hooks/useUpdateCustomerMutation';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { parkingVehicleLicensePlate } from 'states/common';
import { useParkingStore } from 'stores/parkingStore';
import MenuToggleItem from './MenuToggleItem';

const AutomaticVehicleSelectToggleItem: React.FC<{
  hideIcon?: boolean;
}> = ({ hideIcon = false }) => {
  const {
    customer: { applicationPreferences },
  } = useContext(AccountContext);

  const { setParkingVehiclePlate } = useParkingStore((state) => state);
  const selectVehicleAutomatically =
    applicationPreferences?.alwaysSelectVehicle ?? false;

  const { t } = useTranslation();

  const { updateCustomer, loading } = useUpdateCustomerMutation({
    skipRefetch: true,
  });

  const onChange = (value: boolean) => {
    if (loading) {
      return;
    }

    updateCustomer({
      variables: {
        input: {
          applicationPreferences: {
            alwaysSelectVehicle:
              applicationPreferences?.alwaysSelectVehicle === undefined
                ? true
                : value,
          },
        },
      },
    });
    if (!value) {
      parkingVehicleLicensePlate(undefined);
      setParkingVehiclePlate(undefined);
    }
  };

  return (
    <MenuToggleItem
      value={selectVehicleAutomatically}
      onValueChange={onChange}
      menuLabel={'account.automaticVehicleSelect.title'}
      testID={'automatic-vehicle-select'}
      subtitle={
        selectVehicleAutomatically
          ? t('account.automaticVehicleSelect.descriptionOn')
          : t('account.automaticVehicleSelect.descriptionOff')
      }
      iconName={hideIcon ? '' : 'Car-Outlined'}
      loading={loading}
    />
  );
};

export default AutomaticVehicleSelectToggleItem;
